import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Clock } from "lucide-react";
import React from "react";

interface AverageHandlingTimeWidgetData {
  id: string;
  value: number;
  comparisonPercentage: number;
}

const AverageHandlingTimeWidget: React.FC<{ data: AverageHandlingTimeWidgetData; icon?: React.ReactNode; loading?: boolean; error?: string }> = ({ data, loading }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
    <div className="flex flex-row items-center justify-between">
      <div className="text-[14px] font-[500] text-primary dark:text-white truncate">Average Handle Time</div>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <Clock className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The average amount of time that an agent spent on each call includes inbound calls and outbound calls they had accepted within a given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      <WidgetMetricDisplay
        value={data.value}
        comparisonPercentage={data.comparisonPercentage}
        loading={loading}
        format="datetime"
      />
    </div>
  </div>
);

export default AverageHandlingTimeWidget;
